export enum RegistrationType {
    RACE = 1,
    OTHER = 2
}